"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var badge_1 = require("./badge");
var money_1 = require("./money");
var discount = {
    DISCOUNT: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    fragment Discount on Discount {\n      code\n      badge {\n        ...Badge\n      }\n      disclaimer\n      label\n      value {\n        ...Money\n      }\n    }\n  "], ["\n    ", "\n    ", "\n    fragment Discount on Discount {\n      code\n      badge {\n        ...Badge\n      }\n      disclaimer\n      label\n      value {\n        ...Money\n      }\n    }\n  "])), badge_1.default.BADGE, money_1.default.MONEY),
};
exports.default = discount;
var templateObject_1;
